export const common = {
  next: "Próximo",
  previous: "Anterior",
  page: "Página",
  cancel: "Cancelar",
  save: "Salvar",
  scrollToBottom: "Rolar para baixo",
  footer: {
    copyright: "© {{year}} Araria por WeBizz. Todos os direitos reservados.",
    about:
      "Araria é uma plataforma para conversas e interações com IA. Permite ao usuário conversar com modelos de IA, fazer upload de imagens e usar uma variedade de recursos de IA. Araria é um produto Brasileiro Desenvolvido pela WeBizz.",
    menu: "Menu",
    home: "Home",
    blog: "Blog",
    pricing: "Preços",
    products: "Produtos",
    featureRequest: "Solicitar Funcionalidade",
    resources: "Recursos",
    support: "Suporte",
    privacy: "Política de Privacidade",
    terms: "Termos de Serviço",
    accountDeletion: "Exclusão de Conta",
    documentation: "Documentação",
    api: "API",
    contact: "Contato",
    github: "GitHub",
    models: "Serviços de IA",
    arariaPlans: "Planos Araria",
    nuvemshop: "App Nuvem Shop",
  },
  notFound: {
    title: "404",
    heading: "Página Não Encontrada",
    description: "A página que você está procurando não existe ou foi movida.",
    button: "Voltar para a Home",
  },
  folders: {
    create: "Criar",
    new: "Nova Pasta",
    namePlaceholder: "Digite o nome da pasta...",
    rename: "Renomear pasta",
    delete: "Excluir pasta",
    moveTo: "Mover para {{name}}",
    removeFromFolder: "Remover da pasta",
  },
  contact: {
    title: "Contato",
    subtitle: "Entre em contato conosco",
    form: {
      name: "Nome",
      email: "Email",
      company: "Empresa",
      message: "Mensagem",
      submit: "Enviar",
      success: "Mensagem enviada com sucesso",
      error: "Erro ao enviar mensagem",
    },
  },
  user: {
    menu: {
      title: "Menu do Usuário",
      profile: "Perfil",
      payments: "Pagamentos",
      usage: "Uso",
      affiliate: "Programa de Afiliados",
      logout: "Sair",
      settings: "Configurações",
      support: "Atendimento",
      features: "Solicitar Funcionalidade",
    },
  },
  soon: {
    title: "Em breve",
    heading: "Nossa equipe está trabalhando aqui!",
    description: "Acompanhe as novidades em nosso blog e redes sociais.",
    button: "Voltar para a Home",
    blog: "Blog",
  },
};
